import { FC } from 'react';
import { BraFitterStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { H2, H3 } from 'atoms/Typography';
import { BraFitterItem } from './BraFitterItem';
import styles from './styles.module.css';

export const BraFitter: FC<{ blok: BraFitterStoryblok }> = ({ blok }) => {
  const { jumpMarkId, title, subtitle, blocks } = blok;
  const isBlokVisible = title || subtitle || blocks?.length;

  return !isBlokVisible ? null : (
    <Container id={jumpMarkId}>
      <div className={styles.root}>
        {title && <H2 className={styles.title}> {title} </H2>}
        {subtitle && <H3 className={styles.subtitle}> {subtitle} </H3>}

        {!!blocks?.length && (
          <div className={styles.items}>
            {blocks.map((blok) => (
              <BraFitterItem key={blok._uid} blok={blok} />
            ))}
          </div>
        )}
      </div>
    </Container>
  );
};
